module.exports = __webpack_public_path__ + "img/P150T_weapon_6.c92a7ce6.png";